<template>
  <div class="cooperation-page__files-tabs">
    <div class="cooperation-page__files-tab" :class="{ active: tab === 0 }" @click="$emit('change', 0)">
      <span class="cooperation-page__files-tab-title">{{$tCooperation('Send files')}}</span>
      <span
        v-if="sent"
        class="cooperation-page__files-tab-badge"
        :style="{ background: badgeBackground }"
      >{{ sent }}</span>
    </div>

    <div class="cooperation-page__files-tab" :class="{ active: tab === 1 }" @click="$emit('change', 1)">
      <span class="cooperation-page__files-tab-title">{{$tCooperation('Received files')}}</span>
      <span
        v-if="received"
        class="cooperation-page__files-tab-badge"
        :style="{ background: badgeBackground }"
      >{{ received }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      sent: Number,
      received: Number,
      badgeBackground: String,

      tab: {
        type: Number,
        default: 0
      }
    }
  };
</script>
